export function getIdFromApiUrl(url: string | null | undefined): number | null {
  if (!url) return null;
  const last = url.split("/").filter(Boolean).at(-1);
  if (!last) return null;
  const id = Number(last);
  return Number.isFinite(id) ? id : null;
}

